import React, { useContext, useEffect, useState } from "react";
import cx from "classnames";

import global from "../../../scss/dhp.scss";

import ColorBucket from "./ColorBucket";
import { RGBToHex, changeBucketColorAccordingBackground, hexToRGB } from "../../../_helpers/utils";
import { EditorContext } from "../../../containers/editor/EditorLayout";
import { CASESTUDY } from "../../../constants/editor";

let style = Object.assign({}, global);

const CColor = () => {
  let { metadata, widgets, updateWidgets } = useContext(EditorContext);

  let activeElement = document.getElementById(metadata.activeWidgetId[0]);
  let targetWidgetIndex = widgets.findIndex(widget => widget.id === metadata.activeWidgetId[0]);

  const [showTagColor, setShowTagColor] = useState();

  const [tagColor, setTagColor] = useState();
  const [tagBucketColor, setTagBucketColor] = useState();
  const [tagEyeDroppercolor, setTagEyeDroppercolor] = useState();
  const [frameColor, setFrameColor] = useState();
  const [frameBucketColor, setFrameBucketColor] = useState();
  const [frameEyeDroppercolor, setFrameEyeDroppercolor] = useState();
  const [sectionBodyColor, setSectionBodyColor] = useState();
  const [bodyBucketColor, setBodyBucketColor] = useState();
  const [bodyEyeDroppercolor, setBodyEyeDroppercolor] = useState();
  const [sectionBorderColor, setSectionBorderColor] = useState();
  const [borderBucketColor, setBorderBucketColor] = useState();
  const [borderEyeDropperColor, setBorderEyeDropperColor] = useState();
  const [loadCureentFormatting, setLoadCureentFormatting] = useState();
  const [updateContext, setUpdateContext] = useState(false);

  useEffect(() => {
    if (document.querySelector(`#${metadata.activeWidgetId[0]} .portfolio_editor .tags`)) setShowTagColor(true);
    else setShowTagColor(false);
  }, []);

  // change tag color
  useEffect(() => {
    if (tagColor && !loadCureentFormatting) {
      let backgroundColorRange = changeBucketColorAccordingBackground(hexToRGB(tagColor));

      activeElement.querySelectorAll(".portfolio_editor .tags li").forEach(element => {
        element.style.backgroundColor = tagColor; // set header color
        element.style.color = backgroundColorRange === "dark" ? "#ffffff" : "#000000";
      });

      tagColor && setTagBucketColor(backgroundColorRange);
    }
  }, [tagColor]);

  //update tag color from eyedropper
  useEffect(() => {
    if (tagEyeDroppercolor) {
      setUpdateContext(true);
      setLoadCureentFormatting(false);
      setTagColor(tagEyeDroppercolor);
      setTagEyeDroppercolor();
    }
  }, [tagEyeDroppercolor]);

  // change frame color
  useEffect(() => {
    if (frameColor && !loadCureentFormatting) {
      let backgroundColorRange = changeBucketColorAccordingBackground(hexToRGB(frameColor));

      activeElement.querySelectorAll(".portfolio_editor .card .left").forEach(element => {
        element.style.backgroundColor = frameColor;

        if (metadata.activeWidgetType[0] === CASESTUDY) {
          element.querySelectorAll("p").forEach(el => {
            el.style.color = backgroundColorRange === "dark" ? "#ffffff" : "#000000";
          });
        }
      });

      frameColor && setFrameBucketColor(backgroundColorRange);
    }
  }, [frameColor]);

  //update frame color from eyedropper
  useEffect(() => {
    if (frameEyeDroppercolor) {
      setUpdateContext(true);
      setLoadCureentFormatting(false);
      setFrameColor(frameEyeDroppercolor);
      setFrameEyeDroppercolor();
    }
  }, [frameEyeDroppercolor]);

  // change body color
  useEffect(() => {
    if (sectionBodyColor && !loadCureentFormatting) {
      let backgroundColorRange = changeBucketColorAccordingBackground(hexToRGB(sectionBodyColor));

      activeElement.querySelectorAll(".section-body").forEach(element => {
        let contentColor = backgroundColorRange === "dark" ? "#ffffff" : "#000000"; // set section body content color based on background color range

        element.style.backgroundColor = sectionBodyColor; // set section body color
        element.querySelector("h5").style.color = contentColor;
        element.querySelectorAll(".card-text").forEach(el => {
          el.style.color = contentColor;
        });
      });

      sectionBodyColor && setBodyBucketColor(backgroundColorRange);
    }
  }, [sectionBodyColor]);

  //update section body color from eyedropper
  useEffect(() => {
    if (bodyEyeDroppercolor) {
      setUpdateContext(true);
      setLoadCureentFormatting(false);
      setSectionBodyColor(bodyEyeDroppercolor);
      setBodyEyeDroppercolor();
    }
  }, [bodyEyeDroppercolor]);

  // change section border color
  useEffect(() => {
    if (sectionBorderColor && !loadCureentFormatting) {
      activeElement.querySelectorAll(".card").forEach(element => {
        element.style.border = `1px solid ${sectionBorderColor}`;
      });

      sectionBorderColor && setBorderBucketColor(changeBucketColorAccordingBackground(hexToRGB(sectionBorderColor)));
    }
  }, [sectionBorderColor]);

  //update section border color from eyedropper
  useEffect(() => {
    if (borderEyeDropperColor) {
      setUpdateContext(true);
      setLoadCureentFormatting(false);
      setSectionBorderColor(borderEyeDropperColor);
      setBorderEyeDropperColor();
    }
  }, [borderEyeDropperColor]);

  // load current formatting
  useEffect(() => {
    setLoadCureentFormatting(true);

    if (activeElement) {
      let tagColor = activeElement?.querySelector(".portfolio_editor .tags li")?.style.backgroundColor
        ? RGBToHex(activeElement?.querySelector(".portfolio_editor .tags li")?.style.backgroundColor)
        : "#f2f2f2";
      setTagColor(tagColor);
      setTagBucketColor(changeBucketColorAccordingBackground(hexToRGB(tagColor)));

      let frameColor = activeElement?.querySelector(".portfolio_editor .card .left").style.backgroundColor
        ? RGBToHex(activeElement?.querySelector(".portfolio_editor .card .left")?.style.backgroundColor)
        : "#f2f2f2";
      setFrameColor(frameColor);
      setFrameBucketColor(changeBucketColorAccordingBackground(hexToRGB(frameColor)));

      let bodyColor = activeElement?.querySelector(".section-body").style.backgroundColor
        ? RGBToHex(activeElement?.querySelector(".section-body").style.backgroundColor)
        : "#ffffff";
      setSectionBodyColor(bodyColor);
      setBodyBucketColor(changeBucketColorAccordingBackground(hexToRGB(bodyColor)));

      let sectionBorder = activeElement?.querySelector(".card").style.border;
      sectionBorder = sectionBorder ? RGBToHex(`rgb${sectionBorder.split("rgb")[1]}`) : "#4472c4";
      setSectionBorderColor(sectionBorder);
      setBorderBucketColor(changeBucketColorAccordingBackground(hexToRGB(sectionBorder)));
    }
  }, [activeElement]);

  // update context
  useEffect(() => {
    let tableConfig = document.getElementById(metadata.activeWidgetId).getAttribute("data-table-config");
    tableConfig = JSON.parse(tableConfig);

    let colorConfig = {
      tagColor: tagColor,
      tagContentColor: changeBucketColorAccordingBackground(hexToRGB(tagColor)) === "dark" ? "#ffffff" : "#000000",
      frameColor: frameColor,
      frameContentColor: changeBucketColorAccordingBackground(hexToRGB(frameColor)) === "dark" ? "#ffffff" : "#000000",
      sectionBodyColor: sectionBodyColor,
      sectionBodyContentColor:
        changeBucketColorAccordingBackground(hexToRGB(sectionBodyColor)) === "dark" ? "#ffffff" : "#000000",
      sectionBorderColor: sectionBorderColor,
    };

    let newTableConfig = { ...tableConfig, ...colorConfig };
    const jsonString = JSON.stringify(newTableConfig);
    const widgetObject = widgets[targetWidgetIndex];
    let newArray = Object.assign([...widgets], {
      [targetWidgetIndex]: {
        ...widgetObject,
        data: {
          ...widgetObject.data,
          "data-table-config": jsonString,
        },
        innerHTML: document.getElementById(metadata.activeWidgetId[0]).innerHTML,
      },
    });
    updateContext && updateWidgets(newArray);
  }, [tagColor, frameColor, sectionBodyColor, sectionBorderColor]);

  return (
    <>
      {showTagColor && (
        <div className={cx(style["line-controls-wrap"], style["justify-content-start"])}>
          <div className={style["slidelabel"]}>Tag Color</div>
          <ColorBucket
            color={tagColor}
            setColor={setTagColor}
            iconBucketColor={tagBucketColor}
            position={"toolbar"}
            eyedropperColor={tagEyeDroppercolor}
            setEyedropperColor={setTagEyeDroppercolor}
            setLoadCurrentFormatting={setLoadCureentFormatting}
            isHideTransparentOpt={true}
            setUpdateContext={setUpdateContext}
          />
        </div>
      )}

      <div className={cx(style["line-controls-wrap"], style["justify-content-start"])}>
        <div className={style["slidelabel"]}>Frame Color</div>
        <ColorBucket
          color={frameColor}
          setColor={setFrameColor}
          iconBucketColor={frameBucketColor}
          position={"toolbar"}
          eyedropperColor={frameEyeDroppercolor}
          setEyedropperColor={setFrameEyeDroppercolor}
          setLoadCurrentFormatting={setLoadCureentFormatting}
          isHideTransparentOpt={true}
          setUpdateContext={setUpdateContext}
        />
      </div>

      <div className={cx(style["line-controls-wrap"], style["justify-content-start"])}>
        <div className={style["slidelabel"]}>Section Body</div>
        <ColorBucket
          color={sectionBodyColor}
          setColor={setSectionBodyColor}
          iconBucketColor={bodyBucketColor}
          position={"toolbar"}
          eyedropperColor={bodyEyeDroppercolor}
          setEyedropperColor={setBodyEyeDroppercolor}
          setLoadCurrentFormatting={setLoadCureentFormatting}
          isHideTransparentOpt={true}
          setUpdateContext={setUpdateContext}
        />
      </div>

      <div className={cx(style["line-controls-wrap"], style["justify-content-start"])}>
        <div className={style["slidelabel"]}>Section Border</div>
        <ColorBucket
          color={sectionBorderColor}
          setColor={setSectionBorderColor}
          iconBucketColor={borderBucketColor}
          position={"toolbar"}
          eyedropperColor={borderEyeDropperColor}
          setEyedropperColor={setBorderEyeDropperColor}
          setLoadCurrentFormatting={setLoadCureentFormatting}
          isHideTransparentOpt={true}
          setUpdateContext={setUpdateContext}
        />
      </div>
    </>
  );
};

export default CColor;
